import React from 'react'
import styles from '~/styles/atoms/footer/footer.module.scss'

import { addClass } from '~/common/utils/html'
import { agreementPath } from '~/common/define/path'
import { OperatingCompanyUrl } from '~/common/define/url'
import InternalLink from '~/components/atoms/link/InternalLink'
import ExternalLink from '~/components/atoms/link/ExternalLink'
import { IconColor } from '~/components/atoms/icon/Icon'

// Cannot use translation in error page
const PublicFooter = () => {
  return (
    <footer className={styles.footer + addClass(styles.public)}>
      <ul className={styles.list}>
        <a className={styles.item} href={'/'}>
          {/*{t('footer.site')}*/}
          サービスサイト
        </a>
        <a className={styles.item} href={agreementPath()}>
          {/*{t('footer.terms_of_service')}*/}
          利用規約
        </a>
        <ExternalLink className={styles.item} link={OperatingCompanyUrl.PRIVACY} mark color={IconColor.WHITE}>
          {/*{t('footer.privacy_policy')}*/}
          プライバシーポリシー
        </ExternalLink>
        <ExternalLink className={styles.item} link={OperatingCompanyUrl.PROFILE} mark color={IconColor.WHITE}>
          {/*{t('footer.company_profile')}*/}
          会社概要
        </ExternalLink>
      </ul>
    </footer>
  )
}

export default PublicFooter